import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface StructureState {
  mrv: string;
  svg: string;
  casNumberList: string;
  setCasNumberList: (casNumberList: string) => void;
  setSvg: (svg: string) => void;
  setMrv: (mrv: string) => void;
}

export const useStructureStore = create<StructureState>()(
  devtools(
    persist(
      immer((set, get) => ({
        mrv: '',
        svg: '',
        casNumberList: '',
        setSvg(svg) {
          set({ svg });
        },
        setMrv(mrv) {
          set({ mrv });
        },
        setCasNumberList(casNumberList) {
          set({ casNumberList });
        },
      })),
      {
        name: 'structure-store',
        storage: createJSONStorage(() => sessionStorage),
      }
    ),
    {
      name: 'structure-store',
    }
  )
);
